import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './messageDetailModal.module.css';

export default function MessageDetailModal({ show, setShow, message }) {
    const handleClose = () => {
        setShow(false);
    };

    if (!message) return null;

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton className={styles.modalHeader}>
                <Modal.Title>Detalle del Comunicado</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                <div className={styles.messageInfo}>
                    <div className={styles.infoRow}>
                        <span className={styles.label}>Usuario:</span>
                        <span className={styles.value}>{message.userName}</span>
                    </div>
                    <div className={styles.infoRow}>
                        <span className={styles.label}>Fecha:</span>
                        <span className={styles.value}>
                            {new Date(message.date).toLocaleDateString('es-MX', {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </span>
                    </div>
                    {message.shareds && message.shareds.length > 0 && (
                        <div className={styles.infoRow}>
                            <span className={styles.label}>Compartido con:</span>
                            <span className={styles.value}>
                                {message.shareds.map((shared, index) => (
                                    <span key={index} className={styles.sharedUser}>
                                        {shared.userName || 'Usuario'}
                                        {index < message.shareds.length - 1 && ', '}
                                    </span>
                                ))}
                            </span>
                        </div>
                    )}
                </div>
                <div className={styles.messageContent}>
                    <h6 className={styles.contentLabel}>Comunicado:</h6>
                    <div className={styles.messageText}>
                        {message.message}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
